module.exports = __webpack_public_path__ + "static/media/0025.a8e2f4ad.png";